import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import intl from 'react-intl-universal'
import { connect } from 'react-redux'
import Popup from 'react-popup'
import { getOrder, confirmDone, printInvoice, printLabelAgain } from '../actions/PackActions'

const mapStateToProps = state => ({
  authenticated: state.auth.session.id !== false,
  print_invoice_automatically: state.config.print_invoice_automatically,
  order_id: state.router.location.query.order ? parseInt(state.router.location.query.order) : false,
  order: state.pack.order
})

const mapDispatchToProps = dispatch => ({
  getOrderAction: (code, id) => dispatch(getOrder(code, id)),
  confirmDoneAction: () => dispatch(confirmDone()),
  printLabelAgainAction: (order_id) => dispatch(printLabelAgain(order_id)),
  printInvoiceAction: (order_id) => dispatch(printInvoice(order_id))
})

class DoneComponent extends React.Component {
  componentDidMount() {
    const { getOrderAction, authenticated, order_id, order } = this.props
    if(authenticated && !order) getOrderAction(false, order_id)
  }

  confirmDone = () => {
    const {
      order,
      print_invoice_automatically,
      confirmDoneAction
    } = this.props
    if (order.invoice_option && !print_invoice_automatically) {
      Popup.create({
        content: intl.get('Do tego zamówienia wymagana jest faktura, na pewno chcesz kontynuować?'),
        buttons: {
          right: [{
            text: intl.get('Tak'),
            key: 'enter',
            action: function () {
              Popup.close()
              confirmDoneAction()
            }
          },
          {
            text: intl.get('Anuluj'),
            className: 'cancel-button',
            action: function () {
              Popup.close()
            }
          }]
        }
      })
    } else {
      confirmDoneAction()
    }
  }

  printLabelAgain = () => {
    const { order_id, printLabelAgainAction } = this.props
    Popup.create({
      content: intl.get('Na pewno chcesz drukować etykietę jeszcze raz?'),
      buttons: {
        right: [{
          text: intl.get('Tak'),
          key: 'enter',
          action: function () {
            Popup.close()
            printLabelAgainAction(order_id)
          }
        },
        {
          text: intl.get('Anuluj'),
          className: 'cancel-button',
          action: function () {
            Popup.close()
          }
        }]
      }
    })
  }

  printInvoice = () => {
    const { order_id, printInvoiceAction } = this.props
    Popup.create({
      content: intl.get('Na pewno chcesz wydrukować fakturę?'),
      buttons: {
        right: [{
          text: 'Tak',
          key: 'enter',
          action: function () {
            Popup.close()
            printInvoiceAction(order_id)
          }
        },
        {
          text: intl.get('Anuluj'),
          className: 'cancel-button',
          action: function () {
            Popup.close()
          }
        }]
      }
    })
  }

  render() {
    const { authenticated, order } = this.props
    if(!authenticated) return (<Redirect to='/login' />)
    let odoo = window.ODOO.url + (window.ODOO.port?':'+window.ODOO.port:'')
    return (
      <div className="container">
        <div className="ramka done">
          <h2>
            {intl.get('Zapisano!')}
            <div className="subheader">{intl.get('Wszystkie dane zostały poprawnie zapisane w systemie.')}</div>
          </h2>
          { order &&
            <>
              <div className="summary">
                <h4>{intl.get('Zamówienie')} {order.name}</h4>
                <div className="notes f_group">
                  <label>{intl.get('Uwagi klienta')}:</label>
                  <div style={{'fontStyle': 'italic'}}>{order.note}</div>
                </div>
                <div className="stock_location f_group">
                  <label>{intl.get('Sprzedawca')}:</label>
                  <div>{order.shop_id}</div>
                </div>
                <div className="date_order f_group">
                  <label>{intl.get('Data zamówienia')}:</label>
                  <div>{order.date_order}</div>
                </div>
                <div className="amount_total f_group">
                  <label>{intl.get('Kwota zamówienia')}:</label>
                  <div>{order.amount_total}</div>
                </div>
                <div className="carrier f_group">
                  <label>{intl.get('Metoda dostawy')}:</label>
                  <div>
                    <div>{order.carrier_name}</div>
                    <div className="shippinglogo">
                      <img src={`${odoo}/ideaerp_shipment_${order.carrier_comp}/static/img/logo.png`} alt="carrier"/>
                    </div>
                  </div>
                </div>
                <div className="delivery f_group">
                  <label>{intl.get('Adres dostawy')}:</label>
                  <div>
                    <div>{order.delivery_name}</div>
                    <div>{order.delivery_street}</div>
                    <div>{order.delivery_zip} {order.delivery_city}</div>
                  </div>
                </div>
                {order.allegro_account &&
                  <div className="allegro_account f_group">
                    <label>{intl.get('Login Allegro sprzedawcy')}:</label>
                    <div>{order.allegro_account}</div>
                  </div>
                }
                {order.allegro_client_login &&
                  <div className="allegro_client f_group">
                    <label>{intl.get('Login Allegro klienta')}:</label>
                    <div>{order.allegro_client_login}</div>
                  </div>
                }
                <div className="invoice f_group">
                  <label>{intl.get('Potwierdzenie')}:</label>
                  <div>{order.invoice_option ? <strong style={{'color': '#f00'}}>{intl.get('FAKTURA')}</strong> : 'paragon'}</div>
                </div>
              </div>
              <div className="buttons_wrap">
                <div>
                  <button onClick={this.printInvoice} className={`print_invoice ${order.invoice_option?'highlighted':'secondary'}`}>{intl.get('Drukuj fakturę')}</button>
                  <button className="secondary print_label" onClick={this.printLabelAgain}>{intl.get('Ponownie drukuj etykietę')}</button>
                </div>
                <button onClick={this.confirmDone}>{intl.get('Kontynuuj')}</button>
              </div>
            </>
          }
        </div>
      </div>
    )
  }
}

const Done = connect(mapStateToProps, mapDispatchToProps)(DoneComponent)
export default withRouter(Done)
